import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=43ffe5a7"
import script from "./Promotion.vue?vue&type=script&lang=ts"
export * from "./Promotion.vue?vue&type=script&lang=ts"
import style0 from "./Promotion.vue?vue&type=style&index=0&id=43ffe5a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports